<div class="address-validation" [class.mobile]="isMobile">
  <div class="header">
    <h5 class="header__title">Your shipping address</h5>
    <span class="header__subtitle">Select an option below</span>
  </div>
  @if (isMobile) {
    <ng-container *ngTemplateOutlet="orderInfo"></ng-container>
  }
  <div class="warning-banner">
    <pdq-icon icon="Attention" size="smaller" color="#8F6900"></pdq-icon>
    <div class="warning-banner__content">
      <strong>We found an issue with your shipping address</strong>
      @if (!isMobile) {
        <p>Please review the suggestion below and choose which address to use for your delivery</p>
      }
    </div>
  </div>

  @if (!isMobile) {
    <ng-container *ngTemplateOutlet="orderInfo"></ng-container>
  }

  <div class="address-cards">
    <div class="address-card address-card--selected">
      <div class="address-card__header">
        <span class="radio radio--selected"></span>
        <strong>Suggested</strong>
        <span class="badge">Recommended</span>
      </div>
      <div class="address-card__body address-card__body--selected">
        <strong>Sarah Mitchell</strong>
        @if (isMobile) {
          <span>123 Main <span class="diff diff--suggested">Street</span> Apt 4B</span>
          <span>New York, NY <span class="diff diff--suggested">10011-5703</span>, United States</span>
        } @else {
          <span>123 Main <span class="diff diff--suggested">Street</span></span>
          <span>Apt 4B</span>
          <span>New York, NY <span class="diff diff--suggested">10011-5703</span></span>
          <span>United States</span>
        }
      </div>
    </div>

    <div class="address-card">
      <div class="address-card__header">
        <span class="radio"></span>
        <strong>Current Address</strong>
      </div>
      <div class="address-card__body">
        <strong>Sarah Mitchell</strong>
        @if (isMobile) {
          <span>123 Main <span class="diff diff--current">Sret</span>, Apt 4B</span>
          <span>New York, NY <span class="diff diff--current">1001</span>, United States</span>
        } @else {
          <span>123 Main <span class="diff diff--current">Sret</span></span>
          <span>Apt 4B</span>
          <span>New York, NY <span class="diff diff--current">1001</span></span>
          <span>United States</span>
        }
      </div>
      <a class="address-card__edit-link">Edit Address</a>
    </div>
  </div>

  <div class="verified">
    <pdq-icon icon="v_icon" size="small" color="var(--shopify-accent)"></pdq-icon>
    Verified by postal service
  </div>

  <button class="cta-button">Use Suggested Address</button>

  <p class="timer-text">You can make changes for the next 56:32</p>
</div>

<ng-template #orderInfo>
  <div class="order-info" [ngClass]="{ 'order-info--mobile': isMobile }">
    <span class="order-info__number">Order #1042</span> &nbsp;/ <strong>&nbsp;Address Verification</strong>
  </div>
</ng-template>
